<div class="expanded-textarea__container"
  [id]="'expanded-textaera-'+field.id">
  <div class="common-text-editor__container-box"
    [ngClass]="{'common-text-input__container-box--error': field.error}"
    [attr.disabled]="field.noEditable?true:null">
    <div class="common-text-input__block-header">
      <label class="common-text-input__label"
        [for]="'expanded-textarea-'+field.id">
        <span class="common-text-input__text-label">{{expandedTextarea.titleField}}</span>
        @if (field.required) {
          <span class="common-tag__mandatory-text-asterisk">*</span>
        }
        <div class="common-text-input__block-buttons">
          @if (field.description && !expandedTextarea.hideTooltipInfo) {
            <tooltip-info [description]="field.description"
              [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
              [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top">
              <i class="lf-icon-search-text common-icon__md"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="expandedTextarea.inReport"></tooltip-in-report>
          }
        </div>
      </label>

      <div class="common-text-input__buttons-right-header">
        @if(field.isVoiceRecord && (skin === 'dark-blue' || skin === 'gm-law')){
          <button class="common-button__icon-sm-noborder"
            [ngClass]="{'common-button__icon-sm-noborder--disabled':field.noEditable}"
            [disabled]="field.noEditable"
            (click)="recordVoice()">
            <i class="lf-icon-microphone common-icon__md"></i>
          </button>
        }
        <button class="common-button__icon-sm-noborder"
          (click)="handleAccept($event)">
          <i class="lf-icon-collapse-panel common-icon__md"></i>
        </button>
      </div>
    </div>
    @if (field.fieldTypeId === 'rich') {
      <rich-editor
        [tinyMceOptions]="expandedTextarea.tinyMceOptions"
        [modelText]="expandedTextarea.text"
        (emitValue)="expandedTextarea.text = $event.model">
      </rich-editor>
    }@else {
      <div class="expanded-textarea__textarea-container">
        <textarea class="common-text-editor__textarea-editor"
          [id]="'expanded-textarea-'+field.id"
          [name]="'expanded-textarea-'+field.id"
          [placeholder]="'common.write-here' | afTranslate"
          [(ngModel)]="expandedTextarea.text"
          [disabled]="field.noEditable">
        </textarea>
      </div>
    }
    @if (expandedTextarea.hasVoiceRecord) {
      <div class="common-record-audio__field-block">
        <div class="common-record-audio__field-inner-block">
          <i class="lf-icon-sound common-icon__sm"></i>
          <div class="common-record-audio__name-block">
            <p class="common-record-audio__name-text">
              {{expandedTextarea.voiceRecord.name}}
            </p>
          </div>
          <div class="common-record-audio__player-block"
            [ngClass]="{'field-type-text__audio-block--accept-check': expandedTextarea.acceptAceptation && !expandedTextarea.loadFromBack}">
            <button class="common-button__icon-sm-noborder"
              (click)="playRecordVoice()">
              <i class="common-icon__md"
                [ngClass]="{'lf-icon-stop' : startAudio && expandedTextarea.audioLoaded,
                  'lf-icon-play': !startAudio,
                  'lf-icon-refresh field-type-text__refresh-animation':!startAudio && !expandedTextarea.audioLoaded}">
              </i>
            </button>
            <div class="common-record-audio__player-line common-record-audio__player-line--background">
              <div class="common-record-audio__player-line common-record-audio__player-line--active"
                [progressBar]="percentTime">
              </div>
            </div>
            @if ((expandedTextarea.loadFromBack || expandedTextarea.audioLoaded) && !expandedTextarea.lockedSavedConcept) {
              <button class="common-button__icon-sm-noborder"
                (click)="audioDownLoad()">
                <i class="lf-icon-download common-icon__md"></i>
              </button>
            }
            @if(!field.noEditable){
              <button class="common-button__icon-sm-noborder"
                (click)="resetInput()">
                <i class="lf-icon-trash common-icon__md"></i>
              </button>
            }
          </div>
        </div>
      </div>
      <div class="common-button__container-typetext-checkbox">
        <div class="common-button__block-typetext-checkbox"
          [ngClass]="{'common-button__block-typetext-checkbox--mandatory':field.errorInAcceptAceptation}">
          <div class="common-button__block-button-md-checkbox">
            <button class="common-button__icon-md-checkbox"
                [ngClass]="{'common-button__icon-md-checkbox--selected': expandedTextarea.acceptAceptation,
                  'common-button__icon-md-checkbox--disabled': field.noEditable || expandedTextarea.acceptAceptation}"
                (click)="acceptAceptationTerms()">
                <i class="common-icon__md"
                  [ngClass]="expandedTextarea.acceptAceptation?'lf-icon-check-full':'lf-icon-box-inactive'"></i>
            </button>
          </div>
          <div class="common-button__block-text-checkbox">
            <span class="common-button__text-checkbox"
              [ngClass]="{'common-button__text-checkbox--disabled':field.noEditable || expandedTextarea.acceptAceptation}">
              {{field.voiceRecordOkText}}
            </span>
            <span class="common-tag__mandatory-text-asterisk"
              [ngClass]="{'common-tag__mandatory-text-asterisk--disabled': field.noEditable || expandedTextarea.acceptAceptation}">*</span>
          </div>
        </div>
        @if (field.errorInAcceptAceptation) {
          <div class="common-button__block-mandatory">
            <span class="common-button__text-mandatory">Obligatorio</span>
          </div>
        }
      </div>
    }
  </div>
</div>
